interface TabMenusProperties {
  menus: { icon?: JSX.Element; activeIcon?: JSX.Element; name: String; count?: number }[];
  openTab: number;
  setOpenTab: (value: number) => void;
}

/**
 * Tab menu function component
 * @param {any} param0 - The param0
 * @param {any} param0.menus - The menus prop
 * @param {any} param0.openTab - The openTab prop
 * @param {any} param0.setOpenTab - The setOpenTab prop
 */
function TabMenus({ menus, openTab, setOpenTab }: TabMenusProperties) {
  return (
    <div className="tab-menus-warp">
      <ul style={{ '--menu-count': menus.length } as React.CSSProperties}>
        {menus.map((item, index) => (
          <li
            id={`button-${index}`}
            className={openTab === index ? 'tab active' : 'tab'}
            onClick={() => setOpenTab(index)}
            role="presentation">
            <div>
              {openTab === index ? item.activeIcon : item.icon} {item.name}{' '}
              {item?.count !== undefined && item?.count !== null ? (
                <div
                  className="tag tag-danger"
                  style={{
                    top: `${
                      String(item.count).length <= 4 ? -((String(item.count).length - 1) * 2) : -8
                    }px`,
                  }}>
                  {item.count}
                </div>
              ) : (
                ''
              )}
            </div>
          </li>
        ))}
        <li className="bg" />
      </ul>
    </div>
  );
}

export default TabMenus;
